import {Box, Stack} from '@mui/material';
import React, {useEffect} from 'react';
import {Outlet, useLocation} from 'react-router-dom';

import {DynamicImage} from 'presentation/components';
import {DownloadApp} from 'presentation/components/DownloadApp';
import {useHostName} from 'presentation/hooks';
import {useMediaQueries} from 'presentation/pages';
import {usePortalRedirectLinkStore} from 'presentation/pages/public/store/usePortalRedirectLinkStore';
import {AsideContainer, SectionContainer} from './styles';

export function PublicTemplate() {
	const {aboveTablet} = useMediaQueries();
	const {dataHostNameState} = useHostName();
	const portalRedirectLink = usePortalRedirectLinkStore(state => state.portalRedirectLink);
	const resetPortalRedirectLink = usePortalRedirectLinkStore(
		state => state.resetPortalRedirectLink,
	);
	const {pathname} = useLocation();

	useEffect(() => {
		resetPortalRedirectLink();
	}, [pathname]);

	return (
		<Stack direction="row" minHeight="100vh">
			{aboveTablet ? (
				<AsideContainer>
					<DynamicImage />
					<Box sx={{marginLeft: 'auto'}}>{dataHostNameState.ansLogo()}</Box>
				</AsideContainer>
			) : null}
			<SectionContainer slot="section" elevation={6}>
				{portalRedirectLink ? null : <DownloadApp marginBottom="-16px" />}
				<Outlet />
			</SectionContainer>
		</Stack>
	);
}
